import UnAuthConnection from '@/communication/UnAuthConnection'

export default function async ({ commit, getters }, { password = null }) {
  const Username = getters['GET_USERNAME']
  if (!Username || !password) {
    return Promise.reject(new Error('User or Password error'))
  }

  UnAuthConnection.post('/authenticate', { username: Username, password })
    .then((payload) => {
      window.localStorage.setItem('token', payload.data.token)
      window.localStorage.setItem('username', Username)
      window.localStorage.setItem('permissions', JSON.stringify(payload.data.permission))

      commit('SET_RELOGIN', payload.data)

      return Promise.resolve(payload)
    })
    .catch((err) => {
      return Promise.reject(err.response.data.message)
    })
}



// WEBPACK FOOTER //
// ./src/view/login/state/action/DoRelogin.js